var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"headb pointer",on:{"click":function($event){return _vm.$router.push('/')}}},[_c('span',[_vm._v(_vm._s(_vm.title)+" "),_c('span',{staticClass:"title2"},[_vm._v(_vm._s(_vm.title2))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }